import { useState, useEffect, useCallback } from 'react';
import { getInvoiceData } from '../services/api';
import { transformMindeeData } from '../utils/mindeeUtils';

export const useInvoiceData = (invoiceId, locationState) => {
  const [loading, setLoading] = useState(!locationState?.extractedData);
  const [error, setError] = useState('');
  const [rawMindeeData, setRawMindeeData] = useState(null);

  const fetchInvoiceData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getInvoiceData(invoiceId);
      
      // Transform the raw Mindee data into our application format
      const transformedData = transformMindeeData(response.extracted_data);
      
      setError('');
      return transformedData;
    } catch (err) {
      setError('Impossible de récupérer les données de la facture.');
      console.error(err);
      return null;
    } finally {
      setLoading(false);
    }
  }, [invoiceId]);

  const getInitialData = useCallback(async () => {
    // If data is passed via navigation
    if (locationState?.extractedData) {
      // Data is already transformed by transformMindeeData in UploadPage
      if (locationState?.rawMindeeData) {
        setRawMindeeData(locationState.rawMindeeData);
      }
      return locationState.extractedData;
    } else if (invoiceId) {
      // Otherwise, fetch data from API
      return await fetchInvoiceData();
    }
    return null;
  }, [invoiceId, locationState, fetchInvoiceData]);

  return {
    loading,
    error,
    rawMindeeData,
    getInitialData,
    fetchInvoiceData
  };
};